import Button from '@/Components/Button/Button';
import { Dialog, DialogButtons, DialogContent, DialogTitle } from '@/Components/Dialog/Dialog';
import Input from '@/Components/Input/Input';
import Radio from '@/Components/Radio/Radio';
import RadioGroup from '@/Components/Radio/RadioGroup';
import type NewWordsStore from '@/Stores/NewWords/NewWordsStore';
import { observer } from 'mobx-react-lite';
import React, { type MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import NewWordStatus from '../../../Models/NewWords/NewWordStatus';
import Styles from './NewWordDialog.module.scss';

const NewWordWordDialog = observer(({ store }: { store: NewWordsStore }): React.ReactElement => {
    {
        const { t } = useTranslation();
        const detailStore = store.detailStore;

        return (
            <Dialog open={detailStore.state.isOpen} onClose={() => detailStore.setDialogIsOpen(false)}>
                <DialogTitle>{detailStore.state.wordID === 0 ? t('Add') : t('Edit')}</DialogTitle>
                <DialogContent>
                    <div className={Styles.wordDialogContent}>
                        <div className={Styles.wordTextAndLanguage}>
                            <div className={Styles.wordText}>
                                <Input
                                    className={Styles.wordTextInput}
                                    light={true}
                                    label={t('Word')}
                                    value={detailStore.state.word}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        detailStore.setWord(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={Styles.languageRadioButtons}>
                                <RadioGroup id="languageRadioButtons" name={t('Language')}>
                                    <Radio name="languageRadioButtons" value="NL" id="NL" onChange={(e) => detailStore.setLanguage(e.target.value)} checked={detailStore.state.language === 'NL'} />
                                    <Radio name="languageRadioButtons" value="FR" id="FR" onChange={(e) => detailStore.setLanguage(e.target.value)} checked={detailStore.state.language === 'FR'} />
                                </RadioGroup>
                            </div>
                        </div>
                        {detailStore.state.error && <div className={Styles.error}>{detailStore.state.error}</div>}
                    </div>
                </DialogContent>
                <DialogButtons>
                    <AddOrEditWordDialogButtons wordID={detailStore.state.wordID} status={store.state.selectedNewWordsState} addOrEditWordAndCloseDialog={store.addOrEditWordAndCloseDialog} />
                </DialogButtons>
            </Dialog>
        );
    }

    function AddOrEditWordDialogButtons({ wordID, status, addOrEditWordAndCloseDialog }: Readonly<{ wordID: number; status: NewWordStatus; addOrEditWordAndCloseDialog: Function }>): React.ReactElement {
        const { t } = useTranslation();

        const setWordStatusAndCloseDialog = (wordStatus: NewWordStatus | undefined): MouseEventHandler => {
            return (event) => {
                addOrEditWordAndCloseDialog(wordStatus);
            };
        };

        switch (status) {
            case NewWordStatus.New:
                return (
                    <>
                        <Button onClick={setWordStatusAndCloseDialog(NewWordStatus.Approved)}>{t('Approve')}</Button>
                        <Button onClick={setWordStatusAndCloseDialog(NewWordStatus.Ignored)}>{t('Ignore')}</Button>
                    </>
                );
            case NewWordStatus.Approved:
                return (
                    <>
                        <Button onClick={setWordStatusAndCloseDialog(undefined)}>{wordID === 0 ? t('Add') : t('Edit')}</Button>
                        <Button onClick={setWordStatusAndCloseDialog(NewWordStatus.Ignored)}>{t('Ignore')}</Button>
                    </>
                );
            case NewWordStatus.Ignored:
                return (
                    <>
                        <Button onClick={setWordStatusAndCloseDialog(undefined)}>{wordID === 0 ? t('Add') : t('Edit')}</Button>
                        <Button onClick={setWordStatusAndCloseDialog(NewWordStatus.Approved)}>{t('Approve')}</Button>
                    </>
                );
        }
    }
});
export default NewWordWordDialog;
